// Service definitions for HSP
export const EXTERIOR_SERVICES = [
  { 
    id: 'ext-1', 
    name: 'Exterior Painting', 
    description: 'Professional exterior painting services including preparation, priming, and finishing with high-quality paints.' 
  },
  { 
    id: 'ext-2', 
    name: 'Pressure Washing', 
    description: 'Deep cleaning of exterior surfaces including siding, driveways, and patios using professional equipment.' 
  },
  { 
    id: 'ext-3', 
    name: 'Gutter Cleaning', 
    description: 'Complete gutter cleaning and maintenance to prevent water damage and ensure proper drainage.' 
  }
];

export const INTERIOR_SERVICES = [
  { 
    id: 'int-1', 
    name: 'Interior Painting', 
    description: 'Expert interior painting services with color consultation and premium paint application.' 
  },
  { 
    id: 'int-2', 
    name: 'Deep Cleaning', 
    description: 'Comprehensive interior cleaning including floors, surfaces, and hard-to-reach areas.' 
  },
  { 
    id: 'int-3', 
    name: 'Handyman Services', 
    description: 'General repair and maintenance services including fixtures, hardware, and minor installations.' 
  }
];

export const SERVICE_FREQUENCIES = [
  { value: 'monthly', label: 'Monthly' },
  { value: '3months', label: 'Every 3 Months' },
  { value: '6months', label: 'Every 6 Months' },
  { value: 'annual', label: 'Annual' }
];

export const QUOTE_STATUSES = [
  { value: 'new_inquiry', label: 'New Inquiry', color: 'blue' },
  { value: 'quote_sent', label: 'Quote Sent', color: 'orange' },
  { value: 'approved', label: 'Approved / To Be Scheduled', color: 'green' },
  { value: 'scheduled', label: 'Scheduled', color: 'purple' },
  { value: 'completed', label: 'Completed', color: 'cyan' },
  { value: 'cancelled', label: 'Cancelled', color: 'red' }
];

export const KANBAN_COLUMNS = [
  { 
    id: 'new_inquiry', 
    title: 'New Inquiry', 
    color: '#1890FF',
    bgColor: '#E6F7FF',
    borderColor: '#91D5FF'
  },
  { 
    id: 'quote_sent', 
    title: 'Quote Sent', 
    color: '#FA8C16',
    bgColor: '#FFF7E6',
    borderColor: '#FFD591'
  },
  { 
    id: 'approved', 
    title: 'Approved / To Be Scheduled', 
    color: '#52C41A',
    bgColor: '#F6FFED',
    borderColor: '#B7EB8F'
  },
  { 
    id: 'scheduled', 
    title: 'Scheduled', 
    color: '#722ED1',
    bgColor: '#F9F0FF',
    borderColor: '#D3ADF7'
  }
];

export const DEFAULT_QUOTE_AMOUNT = 400;
export const CURRENCY = 'USD';
